import React from 'react';
import { Chip } from '@milanote/roma';

import EmojiImage from '../../../components/emoji/EmojiImage';
import ElementReactionPillTooltip from '../../reactions/ElementReactionPillTooltip';
import PressableChip from '../behaviours/PressableChip';
import type { ElementReactionChipDescriptor } from '../elementChipsTypes';

type ReactionChipProps = {
    chip: ElementReactionChipDescriptor;
    currentUserId?: string;
    canModify: boolean;
    /** Toggles the current user's reaction for this emoji. */
    onPress: () => void;
};

/**
 * Renders a reaction pill for the generic element pills path.
 */
const ReactionChip: React.FC<ReactionChipProps> = ({ chip, currentUserId = '', canModify, onPress }) => {
    const { emojiCode, userIds, isSearchHighlighted } = chip;

    return (
        <PressableChip canPress={canModify} onPress={onPress}>
            <ElementReactionPillTooltip emojiCode={emojiCode} currentUserId={currentUserId} userIds={userIds}>
                <Chip
                    variant={userIds.includes(currentUserId) ? 'user' : 'normal'}
                    count={userIds.length}
                    isDisabled={!canModify}
                    isSearchHighlighted={isSearchHighlighted}
                >
                    <EmojiImage emojiCode={emojiCode} className="size-3" />
                </Chip>
            </ElementReactionPillTooltip>
        </PressableChip>
    );
};

export default ReactionChip;
